module.exports = __webpack_public_path__ + "img/Element_extraction-1.c7b0c807.png";